'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

exports.apiValidator = apiValidator;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _errors = require('../errors');

var _typeUtils = require('./type-utils');

var _utilsBaseValidator = require('../utils/base-validator');

var ApiValidator = (function (_RejectingValidator) {
  _inherits(ApiValidator, _RejectingValidator);

  function ApiValidator() {
    _classCallCheck(this, ApiValidator);

    _get(Object.getPrototypeOf(ApiValidator.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(ApiValidator, [{
    key: 'arity',
    value: function arity(method, args, from, to) {
      return this.addValidation(function () {
        return args.length <= to && args.length >= from;
      }, function () {
        return _errors.messages.invalidArgumentLength(method, from, to, args.length);
      });
    }
  }, {
    key: '_isObject',
    value: function _isObject(item, collectionName) {
      return this.addValidation(function () {
        return (0, _typeUtils.isObject)(item);
      }, function () {
        return _errors.messages.itemMustBeAnObject(item, collectionName);
      });
    }
  }, {
    key: 'item',
    value: function item(_item, collectionName, requireId) {
      return this._isObject(_item, collectionName).addValidation(function () {
        return _item._id !== undefined ? (0, _typeUtils.isString)(_item._id) : !requireId;
      }, function () {
        return _errors.messages.updateItemInvalid();
      });
    }
  }, {
    key: 'items',
    value: function items(_items, collectionName) {
      return this.addValidation(function () {
        return (0, _typeUtils.isArray)(_items) && _items.every(function (item) {
          return (0, _typeUtils.isObject)(item) && (item._id === undefined || item._id === null || (0, _typeUtils.isString)(item._id));
        });
      }, function () {
        return _errors.messages.itemsMustBeArrayOfObjects(collectionName);
      }).addValidation(function () {
        return _items.length <= 1000;
      }, function () {
        return _errors.messages.itemsMustBeLessThanThousand(collectionName);
      });
    }
  }, {
    key: 'fieldName',
    value: function fieldName(_fieldName) {
      return this.addValidation(function () {
        return (0, _typeUtils.isString)(_fieldName);
      }, function () {
        return _errors.messages.fieldNameMustBeAString();
      });
    }
  }, {
    key: 'itemId',
    value: function itemId(_itemId) {
      return this.addValidation(function () {
        return (0, _typeUtils.isString)(_itemId);
      }, function () {
        return _errors.messages.itemIdMustBeAString();
      });
    }
  }, {
    key: '_options',
    value: function _options(options, flags) {
      return this.addValidation(function () {
        var validOptions = (0, _typeUtils.isObject)(options) && flags.every(function (flag) {
          return isBooleanIfDefined(options[flag]);
        });
        return options == null || validOptions;
      }, function () {
        return _errors.messages.optionsInvalid(flags);
      });
    }
  }, {
    key: 'referenceParameters',
    value: function referenceParameters(parameters) {
      return this.addValidation(function () {
        return (0, _typeUtils.isArray)(parameters) && parameters.every(isReferenceParameter);
      }, _errors.messages.referenceOperationParameterError);
    }
  }, {
    key: 'referenceParameter',
    value: function referenceParameter(parameter) {
      return this.addValidation(function () {
        return isReferenceParameter(parameter);
      }, _errors.messages.referenceOperationParameterError);
    }
  }, {
    key: 'references',
    value: function references(refs) {
      return this.addValidation(function () {
        return (0, _typeUtils.isArray)(refs) && refs.every(function (ref) {
          return (0, _typeUtils.isString)(ref.relationshipName) && isReferenceParameter(ref.left) && isReferenceParameter(ref.right);
        });
      }, _errors.messages.invalidReferenceError);
    }
  }, {
    key: 'options',
    value: function options(_options2) {
      return this._options(_options2, ['suppressAuth', 'suppressHooks']);
    }
  }, {
    key: 'bulkInsertOptions',
    value: function bulkInsertOptions(options) {
      return this._options(options, ['suppressAuth', 'suppressHooks', 'overrideExisting']);
    }
  }, {
    key: 'bulkUpdateOptions',
    value: function bulkUpdateOptions(options) {
      return this._options(options, ['suppressAuth', 'suppressHooks']);
    }
  }, {
    key: 'collectionName',
    value: function collectionName(_collectionName) {
      return this.addValidation(function () {
        return (0, _typeUtils.isString)(_collectionName);
      }, function () {
        return _errors.messages.collectionNameMustBeAString();
      });
    }
  }]);

  return ApiValidator;
})(_utilsBaseValidator.RejectingValidator);

function apiValidator() {
  return new ApiValidator();
}

function isBooleanIfDefined(value) {
  return value == null || (0, _typeUtils.isBoolean)(value);
}

function isReferenceParameter(parameter) {
  return (0, _typeUtils.isString)(parameter) || (0, _typeUtils.isObject)(parameter) && parameter.hasOwnProperty('_id');
}